export default {
  state: {
    portfoliosList: [],
    selectedPortfolio: "all"
  },
  actions: {
    changeSelectedPortfolio({ commit, dispatch }, { portfolioId, route_name }) {
      commit("setSelectedPortfolio", portfolioId);
      // Присваиваем все брокеры
      //commit("setSelectedBroker", "all");
      // Присваиваем vp значение null, чтобы показался прелоадер
      if (route_name === "finance-overview") {
        dispatch("fetchIncomeData");
        dispatch("fetchAssetDynamics");
      }

      if (route_name === "finance-securities") {
        commit("unsetUserPortfolio");
        dispatch("fetchUserPortfolio");
      }

      if (route_name === "finance-cash") {
        dispatch("fetchUserCash");
      }

      if (route_name === "finance-debts") {
        dispatch("fetchUserDebit");
      }

      if (route_name === "finance-transactions") {
        // Присваиваем transactions значение null, чтобы показалася прелоадер
        dispatch("fetchTransactions");
      }
      if (route_name === "instruction") {
        dispatch("fetchInstructions");
      }

      commit("unsetVp");
      // Присваиваем unsetCurrencyPortfolio значение null, чтобы показался прелоадер
      commit("unsetCurrencyPortfolio");
      // Загружаем данные по выбранному брокеру
      dispatch("fetchIncomeSinceYearBeginning");
      //
    }
  },
  mutations: {
    setPortfoliosList(state, portfoliosList) {
      // Отлавливаем ошибку на сервере, когда не прилетает portfoliosList
      if (!Array.isArray(portfoliosList)) {
        portfoliosList = [];
      }
      portfoliosList.unshift({ id: "all", name: "Все портфели" });
      state.portfoliosList = portfoliosList;
    },
    setSelectedPortfolio(state, portfolioId) {
      state.selectedPortfolio = portfolioId;
    }
  },
  getters: {
    portfoliosList(state) {
      let portfoliosList = state.portfoliosList || [];
      return portfoliosList.map(portfolio => {
        let portfolioItem = {
          value: portfolio.id,
          text: portfolio.name
        };
        if (portfolio.id === state.selectedPortfolio) {
          portfolioItem.selected = true;
        }
        return portfolioItem;
      });
    },
    selectedPortfolio(state) {
      return state.selectedPortfolio;
    }
  }
};
